module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 59
// module chunks = 2